/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Error_Preview_RejectedInputs */

const vi_einvoice_error_preview_rejected = /** @type {(inputs: Einvoice_Error_Preview_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA từ chối yêu cầu xem trước hóa đơn. Vui lòng kiểm tra dữ liệu hóa đơn rồi thử lại.`)
};

/**

* @param {Einvoice_Error_Preview_RejectedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_error_preview_rejected = /** @type {((inputs?: Einvoice_Error_Preview_RejectedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Error_Preview_RejectedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_error_preview_rejected(inputs)
});